<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import IndowVsReplacements from '$lib/PageSections/IndowVsReplacements/IndowVsReplacements.svelte';
</script>

{#snippet colorRect(text, classNames)}
	<span
		class={[
			classNames,
			`
     mb-4 inline-block w-60 rounded-lg py-10 text-center
     text-[clamp(3rem,8vw,4rem)] font-bold
   `,
		]}
	>
		{text}
	</span>
{/snippet}

{#snippet fullWidthSectionBanner(text)}
	<Section backgroundColor="grey-dark">
		<h2 class="text-left text-3xl font-medium text-indow-white uppercase">
			{text}
		</h2>
	</Section>
{/snippet}

<Section>
	<h1 class="text-left">The Magic Behind Indow Windows</h1>
	<p class="text-left">
		Multiple studies have been carried out by third-party sources testing the
		efficiency of Indow window inserts across a range of categories. Indow
		inserts have multiple functions and capabilities depending on the grade type
		- read the results and see the performance data of all grade types here.
	</p>
</Section>

{@render fullWidthSectionBanner('Energy Efficient Insulation')}

<Section backgroundColor="blue">
	<div
		class="
    flex w-full flex-col gap-6
    md:flex-row md:gap-10
  "
	>
		<div class="text-center">
			{@render colorRect('20%', 'bg-indow-white text-indow-blue')}
			<p class="text-center text-2xl font-medium text-indow-white">
				AVERAGE ENERGY SAVINGS
			</p>
		</div>
		<div>
			<p class="text-left">
				Two independent studies carried out by the U.S. Department of Energy and
				Portland State University's Green Building Research Laboratory found
				reductions of 20% to energy consumption when using Indow window inserts,
				significant savings that allow for lower heating and cooling bills.
			</p>
			<div class="md:inline-block">
				<Button href="/solutions/reduce-energy-waste" color="white"
					>LEARN MORE</Button
				>
			</div>
		</div>
	</div>
</Section>

{@render fullWidthSectionBanner('Noise Reducing Insulation')}

<Section>
	<div
		class="
    flex w-full flex-col-reverse gap-6
    md:flex-row md:gap-10
  "
	>
		<div>
			<p class="text-left">
				Indow window inserts reduce outside noise penetration by up to 70%. This
				was tested in a study conducted by the British Columbia Institute for
				Technology, as well as by Portland State University's Green Building
				Research Laboratory. Be it over single or double-pane windows, Indow
				inserts are proven to dramatically reduce noise.
			</p>
			<div class="md:inline-block">
				<Button href="/solutions/noise-performance" color="blue"
					>LEARN MORE</Button
				>
			</div>
		</div>
		<div class="text-center">
			{@render colorRect('70%', 'bg-indow-blue text-indow-white')}
			<p class="text-center text-2xl font-medium text-indow-blue">
				PEAK NOISE REDUCTION
			</p>
		</div>
	</div>
</Section>

{@render fullWidthSectionBanner('UV Light Protection')}

<Section backgroundColor="blue">
	<div
		class="
    flex w-full flex-col gap-6
    md:flex-row md:gap-10
  "
	>
		<div class="text-center">
			{@render colorRect('98%', 'bg-indow-white text-indow-blue')}
			<p class="text-center text-2xl font-medium text-indow-white">
				UV LIGHT BLOCKING
			</p>
		</div>
		<div>
			<p class="text-left">
				Indow Museum Grade inserts are UV protection for windows to prevent wood
				floors, furniture, and artwork from fading, saving you the cost of
				replacing damaged items. These interior storm windows block 98% of the
				damaging UV radiation coming through your windows.
			</p>
			<div class="md:inline-block">
				<Button href="/products/uv-blocking-window-inserts" color="white"
					>LEARN MORE</Button
				>
			</div>
		</div>
	</div>
</Section>

{@render fullWidthSectionBanner('Total Blackout Solution')}

<Section>
	<div
		class="
    flex w-full flex-col-reverse gap-6
    md:flex-row md:gap-10
  "
	>
		<div>
			<p class="text-left">
				Sleep Panels seal out light for total darkness and also block up to 50%
				of noise coming through windows* to create an ideal sleep environment.
				Unlike blackout curtains, shades or blinds, which allow some light
				around the borders, Indow Sleep Panel is edged in silicone compression
				tubing to create true blackout windows.
			</p>
			<div class="md:inline-block">
				<Button href="/products/sleep-panels" color="blue">LEARN MORE</Button>
			</div>
		</div>
		<div class="text-center">
			{@render colorRect('100%', 'bg-indow-blue text-indow-white')}
			<p class="text-center text-2xl font-medium text-indow-blue">
				LIGHT BLOCKING
			</p>
		</div>
	</div>
</Section>

{@render fullWidthSectionBanner('Top-Rated Performance')}

<Section backgroundColor="grey-light">
	<div
		class="
    flex w-full flex-col-reverse gap-6
    md:flex-row md:gap-10
  "
	>
		<div>
			<p class="text-left">
				The Attachments Energy Rating Council (AERC) rates window attachment
				products on energy efficiency by measuring various factors such as Air
				Leakage (AL) and U-Factor.
			</p>
			<p class="text-left">
				Indow scored 2nd out of 33 storm windows tested in Air Leakage and
				scored a U-Factor (a measure of heat transfer) of 0.3, making our
				inserts a top performer among all available storm windows.
			</p>
		</div>
		<div class="text-center">
			{@render colorRect('#2', 'bg-indow-grey-dark text-indow-white')}
			<p class="text-center text-2xl font-medium text-indow-grey-dark">
				IN AIR LEAKAGE TESTING
			</p>
		</div>
	</div>
</Section>

<Section>
	<IndowVsReplacements />
</Section>
<GetFreeEstimate />
